const USERS = 'USERS';
const USER_SETTINGS = 'USER_SETTINGS';
const PROJECT_ADD = 'PROJECT_ADD';
const PROJECT_SETTINGS = 'PROJECT_SETTINGS';
// FAMILY-EXT: модал управления внешними хранилищами
const EXTERNAL_STORAGES = 'EXTERNAL_STORAGES';

export default {
  USERS,
  USER_SETTINGS,
  PROJECT_ADD,
  PROJECT_SETTINGS,
  EXTERNAL_STORAGES,
};
